export const remapUserDto = (user) => {
    return {
        ...user,
        pendingInvitation: user.pendingInvitation
            ? {
                id: user.pendingInvitation.invitationId,
                linkSecret: user.pendingInvitation.eLinkSecretByUserKey,
                isEncrypted: true,
            }
            : null,
    };
};
